import type { AutoCompleteDesignTokens } from '@primeuix/themes/types/autocomplete'

export default {
  chip: {
    borderRadius: '{border.radius.sm}',
  },
  list: {
    gap: '{list.gap}',
    padding: '{list.padding}',
  },
  root: {
    color: '{form.field.color}',
    shadow: '{form.field.shadow}',
    paddingX: '{form.field.padding.x}',
    paddingY: '{form.field.padding.y}',
    focusRing: {
      color: '{form.field.focus.ring.color}',
      style: '{form.field.focus.ring.style}',
      width: '{form.field.focus.ring.width}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
    background: '{form.field.background}',
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    disabledColor: '{form.field.disabled.color}',
    filledBackground: '{form.field.filled.background}',
    focusBorderColor: '{form.field.focus.border.color}',
    hoverBorderColor: '{form.field.hover.border.color}',
    placeholderColor: '{form.field.placeholder.color}',
    disabledBackground: '{form.field.disabled.background}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    transitionDuration: '{form.field.transition.duration}',
    filledFocusBackground: '{form.field.filled.focus.background}',
    filledHoverBackground: '{form.field.filled.hover.background}',
    invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
  },
  option: {
    color: '{list.option.color}',
    padding: '{list.option.padding}',
    focusColor: '{list.option.focus.color}',
    borderRadius: '{list.option.border.radius}',
    selectedColor: '{list.option.selected.color}',
    focusBackground: '{list.option.focus.background}',
    selectedBackground: '{list.option.selected.background}',
    selectedFocusColor: '{list.option.selected.focus.color}',
    selectedFocusBackground: '{list.option.selected.focus.background}',
  },
  overlay: {
    color: '{overlay.select.color}',
    shadow: '{overlay.select.shadow}',
    background: '{overlay.select.background}',
    borderColor: '{overlay.select.border.color}',
    borderRadius: '{overlay.select.border.radius}',
  },
  dropdown: {
    lg: {
      width: '3rem',
    },
    sm: {
      width: '2rem',
    },
    width: '2.5rem',
    focusRing: {
      color: '{form.field.focus.ring.color}',
      style: '{form.field.focus.ring.style}',
      width: '{form.field.focus.ring.width}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    hoverBorderColor: '{form.field.border.color}',
    activeBorderColor: '{form.field.border.color}',
  },
  colorScheme: {
    dark: {
      chip: {
        focusColor: '{surface.0}',
        focusBackground: '{surface.700}',
      },
      dropdown: {
        color: '{surface.300}',
        background: '{surface.800}',
        hoverColor: '{surface.200}',
        activeColor: '{surface.100}',
        hoverBackground: '{surface.700}',
        activeBackground: '{surface.600}',
      },
    },
    light: {
      chip: {
        focusColor: '{surface.800}',
        focusBackground: '{surface.200}',
      },
      dropdown: {
        color: '{surface.600}',
        background: '{surface.50}',
        hoverColor: '{surface.700}',
        activeColor: '{surface.800}',
        hoverBackground: '{surface.100}',
        activeBackground: '{surface.200}',
      },
    },
  },
  optionGroup: {
    color: '{list.option.group.color}',
    padding: '{list.option.group.padding}',
    background: '{list.option.group.background}',
    fontWeight: '{list.option.group.font.weight}',
  },
  emptyMessage: {
    padding: '{list.option.padding}',
  },
} satisfies AutoCompleteDesignTokens
